module.exports = __webpack_public_path__ + "static/img/carousel1.28a44d3a.png";